module.exports = __webpack_public_path__ + "static/aimlc_logo-fc7d04205520dd963450cc50836e1034.png";